import React from 'react';

import ListItemContainer from '../../../sharable/components/dashboardListItem/ListItemContainer';
import ListItemDetailsContainer from '../../../sharable/components/dashboardListItem/ListItemDetailsContainer';
import ListItemContentContainer from '../../../sharable/components/dashboardListItem/ListItemContentContainer';
import ListItemActionsContainer from '../../../sharable/components/dashboardListItem/ListItemActionsContainer';
import ArticlesItemDetails from '../ArticlesItemDetails';
import ArticlesItemContent from '../ArticlesItemContent';
import ArticlesItemActions from '../ArticlesItemActions';

interface IArticlesListItemProps {
  articleId: string;
}

const ArticlesListItem: React.FC<IArticlesListItemProps> = ({ articleId }) => {
  return (
    <ListItemContainer>
      <ListItemDetailsContainer>
        <ArticlesItemDetails articleId={articleId} />
      </ListItemDetailsContainer>
      <ListItemContentContainer>
        <ArticlesItemContent articleId={articleId} />
      </ListItemContentContainer>
      <ListItemActionsContainer>
        <ArticlesItemActions articleId={articleId} />
      </ListItemActionsContainer>
    </ListItemContainer>
  );
};

export default ArticlesListItem;
